// extracted by mini-css-extract-plugin
export default {"title":"EducationalResourcesTable_title__PS4rb","tableHeader":"EducationalResourcesTable_tableHeader__KU-HB","downloadButton":"EducationalResourcesTable_downloadButton__m1Lku"};